export default "/images/vendor/flag-icon-css/flags/4x3/gf.svg?695a47d62497dc58466740984bbe3b4f";